export * from "./protocol-messages.js";
// Only the selector forms this package emits in page_context sections:
// "#id" (optionally CSS-escaped) or [data-voice-section="..."].
const ID_SELECTOR_RE = /^#(?:[A-Za-z0-9_\u00a0-\uffff-]|\\[0-9a-fA-F]{1,6} ?|\\.)+$/;
const VOICE_SECTION_SELECTOR_RE = /^\[data-voice-section="(?:[^"\\]|\\.)*"\]$/;
function isSectionSelector(s) {
    return ID_SELECTOR_RE.test(s) || VOICE_SECTION_SELECTOR_RE.test(s);
}
export function parseEvent(raw) {
    try {
        return validateEvent(JSON.parse(raw));
    }
    catch {
        return null;
    }
}
export function validateEvent(obj) {
    if (!obj || typeof obj !== 'object')
        return null;
    const o = obj;
    switch (o.type) {
        case 'navigate_to_page':
            if (typeof o.path !== 'string' || typeof o.reason !== 'string')
                return null;
            return { type: 'navigate_to_page', path: o.path, reason: o.reason };
        case 'scroll_to_section':
            if (typeof o.selector !== 'string' || typeof o.summary !== 'string')
                return null;
            if (!isSectionSelector(o.selector))
                return null;
            return { type: 'scroll_to_section', selector: o.selector, summary: o.summary };
        case 'page_context':
            if (typeof o.path !== 'string' ||
                typeof o.title !== 'string' ||
                !Array.isArray(o.sections)) {
                return null;
            }
            return {
                type: 'page_context',
                path: o.path,
                title: o.title,
                sections: o.sections.filter((s) => !!s && typeof s === 'object' &&
                    typeof s.label === 'string' &&
                    typeof s.selector === 'string'),
                ...(typeof o.timeZone === 'string' ? { timeZone: o.timeZone } : {}),
            };
        case 'request_page_context':
            return { type: 'request_page_context' };
        case 'show_booking_form':
            return { type: 'show_booking_form' };
        case 'show_booking_times':
            return { type: 'show_booking_times' };
        case 'slot_selected':
            if (typeof o.start !== 'string')
                return null;
            return { type: 'slot_selected', start: o.start };
        case 'human_handoff_requested':
            if (typeof o.handoff_id !== 'string')
                return null;
            return {
                type: 'human_handoff_requested',
                handoff_id: o.handoff_id,
                ...(typeof o.reason === 'string' ? { reason: o.reason } : {}),
            };
        case 'human_handoff_joined':
            if (typeof o.handoff_id !== 'string')
                return null;
            return {
                type: 'human_handoff_joined',
                handoff_id: o.handoff_id,
                ...(typeof o.operator_name === 'string'
                    ? { operator_name: o.operator_name }
                    : {}),
            };
        case 'human_handoff_unavailable':
            if (typeof o.handoff_id !== 'string')
                return null;
            return { type: 'human_handoff_unavailable', handoff_id: o.handoff_id };
        case 'intake_opened':
            return { type: 'intake_opened' };
        case 'intake_completed': {
            if (!o.responses || typeof o.responses !== 'object' || Array.isArray(o.responses)) {
                return null;
            }
            const responses = o.responses;
            if (!Object.values(responses).every((v) => typeof v === 'string'))
                return null;
            return { type: 'intake_completed', responses: responses };
        }
        default:
            return null;
    }
}
export function encodeEvent(ev) {
    return new TextEncoder().encode(JSON.stringify(ev));
}
